// extracted by mini-css-extract-plugin
export var arrows = "_1p-6";
export var decrementer = "_1p-a";
export var disabled = "_1p-4";
export var error = "_1p-1";
export var hiddenText = "_1p-b";
export var incrementer = "_1p-9";
export var input = "_1p-8";
export var inputWrapper = "_1p-0";
export var leadingIcon = "_1p-c";
export var readonly = "_1p-3";
export var regular = "_1p-7";
export var small = "_1p-5";
export var warning = "_1p-2";